import styled from 'styled-components'
import { breakpointUpTo } from 'utils/breakpoints'

export const ExternalLink = styled.a`
  display: flex;
  place-items: center;
  color: ${({ theme }) => theme.colors.primary};
  ${({ theme }) => theme.typography.LrgBody2}
  text-decoration: none;

  svg {
    margin-left: ${({ theme }) => theme.space[0]};
    transition: 0.2s opacity;
    opacity: 0.3;
  }
  &:hover,
  &:active {
    text-decoration: underline;
    svg {
      opacity: 1;
    }
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.MedBody2}
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    ${({ theme }) => theme.typography.SmBody2}
  }
`
